import Image from '@components/Image'
import './index.scss'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import { useInView } from 'react-intersection-observer'

const GridImageText_1 = (props: RealEstateDataPageComponentData) => {
  const { title, subtitle, items, upperCaseLink } = props

  const { ref, inView } = useInView({
    triggerOnce: false, // Cargar solo una vez cuando sea visible
  })

  return (
    <section
      className={'grid_image_text_1 p-y-config'}
      id="Descripción"
    >
      <Container fluid>
        <Row className="justify-content-center">
          <Col
            className="mb-5"
            xs={12}
          >
            {title && (
              <h2 className={`text-center ${upperCaseLink ? 'text-uppercase' : ''}`}>{title}</h2>
            )}
            {subtitle && <p className="text-center">{subtitle}</p>}
          </Col>
          <Col
            ref={ref}
            lg={11}
          >
            {items?.map((item, index) => (
              <Row
                className={
                  inView
                    ? index % 2 == 1
                      ? ' animate__animated animate__fadeInRight '
                      : 'animate__animated animate__fadeInLeft'
                    : ''
                }
                key={index}
              >
                <Col
                  xs={{ span: 12, order: 2 }}
                  lg={{ span: 7, order: index % 2 == 1 ? 2 : 1 }}
                >
                  <Image
                    className="w-100 h-100 no-border "
                    objectFit="cover"
                    alt="about-us-img"
                    image={item.image_gatsby!!}
                    hrefImage={item.image}
                  />
                </Col>
                <Col
                  xs={{ span: 12, order: 1 }}
                  lg={{ span: 5, order: index % 2 == 1 ? 1 : 2 }}
                  className="d-flex flex-column justify-content-center align-items-center"
                >
                  <div className="content-grid text-center text-lg-start">
                    <span className="mb-3 d-block">{item.subtitle}</span>
                    <h3 className="mb-lg-4 mb-3 mt-2 mt-lg-3">{item.title}</h3>
                    <p>{item.paragraph}</p>
                  </div>
                </Col>
              </Row>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default GridImageText_1
